module.exports = __webpack_public_path__ + "static/img/psp.2f95ac69.png";